/* eslint-disable */
export function htmlDecodeByRegExp(str, type) {
  let s = '';
  let repNum = 0;
  if (str) {
    if (str.length === 0) return '';
    s = str.replace(/&amp;/g, '&');
    s = s.replace(/&lt;/g, ' < ');
    s = s.replace(/&gt;/g, ' > ');
    s = s.replace(/&nbsp;/g, ' ');
    s = s.replace(/<br\/>/g, '');
    s = s.replace(/<stong\/>/g, '');
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, '"');
    s = s.replace(/\$/g, ' $ ');
    s = s.replace(/<\/?font[^>]{0,}>/g, '');
    s = s.replace(/【high(\d)*?】/g, '');
    s = s.replace(/【\/high(\d)*?】/g, '');
    s = s.replace(/【下划线】/g, '<u>', s);
    s = s.replace(/【\/下划线】/g, '</u>', s);
    s = s.replace(/【【题干】/g, '', s);
    s = s.replace(/\/题干】/g, '', s);
    if (type) {
      // type = 1  不可编辑
      s = s.replace(/___\d___/g, (s, i) => {
        repNum++;
        return (
          // '<span id="answer_' + repNum + '" class="imitate_input"><em>___</em><i class="icon-num">'+repNum+'</i><em>___</em></span>'
          `<span id="answer_${repNum}" class="imitate_input">______</span>`
        );
      });
      s = s.replace(/\#\#\$\$\#\#/g, (s, i) => {
        repNum++;
        return (
          `<span id="answer_${repNum}" class="imitate_input">______</span>`
          // '<span id="answer_' + repNum + '" class="imitate_input"><em>______</em><i class="icon-num">'+repNum+'</i><em>___</em></span>'
        );
      });
      s = s.replace(/\|\|([0-9a-zA-Z\u4e00-\u9fa5]*)\|\|/g, (s, i) => (`<span class="paragraph-title-x">|| ${i}</span>`));
    } else {
      s = s.replace(/___\d___/g, (s, i) => {
        repNum++;
        // nothing
        // return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
        return (
          `<span id="answer_${
            repNum
          }" class="imitate_input"contentEditable="true"  @keyup="editnameSet($event)">______</span>`
        );
      });
      s = s.replace(/\#\#\$\$\#\#/g, (s, i) => {
        repNum++;
        // return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
        return (
          `<span id="answer_${
            repNum
          }" class="imitate_input" contentEditable="true">______</span>`
        );
      });
    }
    return s;
  }
}
export function isString (obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object string]') {
    return true
  }
  return false
}
export function checkFillAnswerIsChinese (str) {
  const regx = /^[\u4e00-\u9fa5]+$/
  if (isString(str) && regx.test(str)) {
    return true
  }
  return false
}

export function getPercentTime (time) {
  let m = Math.floor(time / 60) > 10 ? Math.floor(time / 60) : '0' + Math.floor(time / 60)
  let s = (time - m * 60) >= 10 ? (time - m * 60) : '0' + (time - m * 60)
  return m + ':' + s
}

export function formatSeconds (result) {
  var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
  var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
  return result = h + ':' + m + ':' + s
}
export function formatTimeBySubject(subject,num) {
  switch (subject) {
    case "数学":
      if(num<=50){
        return formatSeconds(num*35)
      }else if(num>50&&num<=100){
        return formatSeconds(num*30)
      }else{
        return formatSeconds(num*24)
      }
    case "英语":
      return formatSeconds(num*30)
    case "语文":
      if(num<=50){
        return formatSeconds(num*60)
      }else{
        return formatSeconds(num*50)
      }
    default:
     if(num<=100){
        return formatSeconds(num*32)
      }else{
        return formatSeconds(num*28)
      }
  }
}
export function getQueryString (name) {
  var search = window.location.href.split('?')[1]
  if (search) {
    var params = search.split('&')
    var obj = {}

    for (var i = 0, l = params.length; i < l; i++) {
      var tmp = params[i].split('=')
      obj[tmp[0]] = tmp[1]
    }

    return obj[name] || ''
  }
  return ''
}

export function getBrowserVersions () {
  var u = navigator.userAgent
  return {
    // 移动终端浏览器版本信息
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
    iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, // 是否iPad
    webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
  }
}

// 用户代理
export function getUAString () {
  return navigator.userAgent
};
export function getOSInfo () {
  var item, token, ua, _i, _len
  ua = navigator.userAgent
  token = [['Windows NT 5.1', 'WinXP'], ['Windows NT 6.0', 'WinVista'], ['Windows NT 6.1', 'Win7'], ['Windows NT 5.2', 'Win2003'], ['Windows NT 5.0', 'Win2000'], ['Macintosh', 'Macintosh'], ['Windows', 'WinOther'], ['Ubuntu', 'Ubuntu'], ['Linux', 'Linux']]
  for (_i = 0, _len = token.length; _i < _len; _i++) {
    item = token[_i]
    if (ua.indexOf(item[0]) > -1) {
      return item[1]
    }
  }
  return 'Other'
};

// 浏览器信息
export function getBrowserInfo () {
  var item, token, ua, _i, _len
  ua = navigator.userAgent
  token = ['Edge', 'Chrome', 'Safari', 'Opera', 'MSIE 6', 'MSIE 7', 'MSIE 8', 'Firefox']
  for (_i = 0, _len = token.length; _i < _len; _i++) {
    item = token[_i]
    if (ua.indexOf(item) > -1) {
      return item.replace(' ', '')
    } else if (ua.indexOf('Trident') > -1 && ua.indexOf('rv:11') > -1) {
      return 'IE11'
    } else if (ua.indexOf('MSIE') > -1 && ua.indexOf('Trident') > -1) {
      return 'IE(8-10)'
    } else if (ua.indexOf('MSIE') > -1) {
      return 'IE(6-7)'
    }
  }
  return 'Other'
};
export function getFlashVersion () {
  var axo, e
  try {
    try {
      axo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.6')
      try {
        axo.AllowScriptAccess = 'always'
      } catch (_error) {
        e = _error
        return '6,0,0'
      }
    } catch (_error) {
      e = _error
    }
    return new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version').replace(/\D+/g, ',').match(/^,?(.+),?$/)[1]
  } catch (_error) {
    e = _error
    try {
      if (navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
        return (navigator.plugins['Shockwave Flash 2.0'] || navigator.plugins['Shockwave Flash']).description.replace(/\D+/g, ',').match(/^,?(.+),?$/)[1]
      }
    } catch (_error) {
      e = _error
    }
  }
  return '0,0,0'
};
// COOKIE状态
export function getCookieEnable () {
  return document.cookie || navigator.cookieEnabled
};
// LocalStorage 状态
export function getLocalStorageEnable () {
  return window.localStorage
};

export function getUrlVia (url, cb) {
  var xmlhttp
  xmlhttp = null
  if (window.XMLHttpRequest) { // code for IE7, Firefox, Opera, etc.
    xmlhttp = new XMLHttpRequest()
  } else if (window.ActiveXObject) { // code for IE6, IE5
    xmlhttp = new ActiveXObject('Microsoft.XMLHTTP')
  }
  if (xmlhttp != null) {
    xmlhttp.onreadystatechange = state_Change
    xmlhttp.open('GET', url, true)
    xmlhttp.send(null)
  } else {
    alert('Your browser does not support XMLHTTP.')
  }
  function state_Change () {
    if (xmlhttp.readyState == 4) {
      cb(xmlhttp.getAllResponseHeaders())
    }
  }
};
export function intToChinese (str) {
  str = str + ''
  var len = str.length - 1
  var idxs = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
  var num = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  return str.replace(/([1-9]|0+)/g, function ($, $1, idx, full) {
    var pos = 0
    if ($1[0] != '0') {
      pos = len - idx
      if (idx == 0 && $1[0] == 1 && idxs[len - idx] == '十') {
        return idxs[len - idx]
      }
      return num[$1[0]] + idxs[len - idx]
    } else {
      var left = len - idx
      var right = len - idx + $1.length
      if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
        pos = left - left % 4
      }
      if (pos) {
        return idxs[pos] + num[$1[0]]
      } else if (idx + $1.length >= len) {
        return ''
      } else {
        return num[$1[0]]
      }
    }
  })
}
